<div class="disasters-section">
  <h3>{{ 'Стихийные бедствия' | translate }}</h3>
  <div class="disasters-table">
    <table>
      <thead>
        <tr>
          <th>{{ 'Name2' | translate }}</th>
          <th>{{ 'Count' | translate }}</th>
          <th>{{ 'Total area' | translate }}</th>
          <th>{{ '% of area' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (disaster of allNaturalDisasters; track disaster) {
          <tr>
            <td (click)="onDisasterClick(disaster)">
              {{ 'FrostDanger' | translate }}<br>
            </td>
            <td>
              {{ disaster.count }}<br>
            </td>
            <td>
              {{ disaster.area | number:'1.2-2' }} {{ 'weather.unity.total.area' | translate }}<br>
            </td>
            <td>
              {{ disaster.percent | number:'1.2-2' }}%
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
